import { isEmptyObject } from '@freelancelabs/utils';

import { createApiError } from './ApiError';

const appendQueryParams = (url: URL, params: { [key: string]: any }) => {
    Object.keys(params).forEach((key) => {
        const value = params[key];
        if (typeof value === 'undefined') {
            return;
        }
        url.searchParams.append(key, value);
    });
};

export const createUrl = (urlString: string, params: { [key: string]: any } = {}) => {
    let url: URL;
    if (typeof window !== 'undefined') {
        url = new URL(urlString, window.location.origin);
    } else {
        url = new URL(urlString);
    }
    appendQueryParams(url, params);
    return url;
};

export const checkStatus = (response: Response, config: any) => {
    const { status } = response;

    if (status >= 200 && status < 300) {
        return response;
    }

    return response
        .json()
        .catch(() => {
            return {};
        })
        .then((data) => {
            throw createApiError('StatusCodeError', response, config, data);
        });
};

export const serializeFormData = (data: { [key: string]: any }) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
            data[key].forEach((val: any) => formData.append(key, val));
        } else {
            formData.append(key, data[key]);
        }
    });
    return formData;
};

export const serializeData = (data: any, input: string) => {
    if (isEmptyObject(data)) {
        return {};
    }
    if (input === 'json') {
        return {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        };
    }
    if (input === 'form') {
        return {
            body: serializeFormData(data),
        };
    }
    return {};
};
